import { Injectable, signal } from '@angular/core';

export interface UserConsent {
    cookies: boolean;
    location: boolean;
    marketing: boolean;
    timestamp: string;
}

@Injectable({
    providedIn: 'root'
})
export class PrivacyService {
    private readonly STORAGE_KEY = 'rg_user_consent';

    consent = signal<UserConsent | null>(this.loadConsent());

    constructor() { }

    private loadConsent(): UserConsent | null {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        if (stored) {
            try {
                return JSON.parse(stored);
            } catch (e) {
                console.error('Error parsing stored consent', e);
                return null;
            }
        }
        return null;
    }

    setConsent(consent: Partial<UserConsent>) {
        const current = this.consent() || {
            cookies: false,
            location: false,
            marketing: false,
            timestamp: new Date().toISOString()
        };

        const updated = {
            ...current,
            ...consent,
            timestamp: new Date().toISOString()
        };

        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(updated));
        this.consent.set(updated);
    }

    hasConsentedToCookies(): boolean {
        return this.consent()?.cookies || false;
    }

    hasConsentedToLocation(): boolean {
        return this.consent()?.location || false;
    }
}
